import React from "react";
import { CheckIcon, ShieldCheckIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
const steps = ["Explore the six volumes.", "Review the comparison tables.", "Work through the educational cases.", "Use the interpretation worksheets and quick-reference tools."];
export function Guarantee() {
  return <section className="bg-ink px-4 py-16 sm:py-20" aria-labelledby="guarantee" data-id="element-165" data-mp="1x4uxxgby3p8z">
      <div className="mx-auto max-w-3xl text-center" data-id="element-166" data-mp="19fsh2ap4y0fj">
        <div className="mx-auto flex h-28 w-28 flex-col items-center justify-center rounded-full border-4 border-gold bg-navy text-gold" data-id="element-167" data-mp="14fo3asfm3jt0">
          <ShieldCheckIcon className="h-9 w-9" aria-hidden="true" data-id="element-168" data-mp="1j5lttf10klld" />
          <span className="mt-1 font-display text-xl font-extrabold uppercase leading-none" data-id="element-169" data-mp="1ee3ueven2t2i">7 Days</span>
        </div>
        <h2 id="guarantee" className="mt-6 font-display text-[34px] font-extrabold uppercase leading-[1.02] text-white sm:text-5xl" data-id="element-170" data-mp="qnhmd44mx8si">
          Your 7-day satisfaction guarantee
        </h2>
        <p className="mt-4 text-[17px] leading-relaxed text-mist" data-id="element-171" data-mp="p01gq64juz97">
          Explore the Blueprint and decide whether it meets your learning needs. After purchasing, you'll have seven days to review the material.
        </p>

        <ul className="mx-auto mt-6 max-w-md space-y-2.5 text-left" data-id="element-172" data-mp="yqmcllsu9pof">
          {steps.map(s => <li key={s} className="flex gap-3 text-[16px] text-white" data-id="element-173" data-mp="12pmt2xnugg89">
              <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-after" strokeWidth={3} aria-hidden="true" data-id="element-174" data-mp="616z8pdpbkpc" />
              {s}
            </li>)}
        </ul>

        <p className="mt-6 text-[16px] leading-relaxed text-mist" data-id="element-175" data-mp="b1laegalnarl">
          If the product does not meet the expectations described in the offer, you can request a refund within seven days under the published refund policy.
        </p>
        <p className="mt-3 text-[18px] font-bold text-white" data-id="element-176" data-mp="1qhackuis0p0i">Your purchase should be a straightforward decision.</p>

        <CtaButton className="mt-10" label="Try it risk-free for 7 days" data-id="element-177" data-mp="1veaj16jjfts5" />
      </div>
    </section>;
}